<template>
  <div>
    <base-card>
      <v-card-text>
        <div
          class="d-flex flex-column align-center justify-center text-center py-3"
        >
          <h2 class="mb-5">Formulario de registro de clientes</h2>
        </div>
      </v-card-text>
    </base-card>
    <v-container
      v-if="!showValidatorModal"
      fluid
      class="d-flex align-center justify-center mw-container"
    >
      <base-card>
        <v-card-title class="d-flex flex-column align-center text-center">
          <v-row>
            <v-col cols="12" md="12">
              <img :src="imageLogo" alt="Logo Compañia" class="logo" />

              <div class="title">
                <h3>{{ titleForm }}</h3>
              </div>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <p>Los campos marcados con <span class="required-asterisk">*</span>, son obligatorios para continuar.</p>
          <div class="d-flex flex-column align-center text-center py-6">
          
            <v-form ref="form" v-model="formValid">
              <v-row dense>
                <v-col
                  v-for="(field, index) in visibleFormConfig"
                  :key="field.id"
                  cols="12"
                  :md="isCheckbox(field) ? 12 : 6"
                >
                  <!-- INPUTS -->
                  <template v-if="!isCheckbox(field)">
                    <div class="field-label">
                      <span class="count-input">{{ index + 1 }}</span>.
                      {{ getFieldLabel(field) }}
                      <span v-if="field.required" class="required-asterisk">*</span>
                    </div>

                    <component
                      :is="resolveComponent(field)"
                      :ref="field.name"
                      v-model="formModel[field.name]"
                      :items="
                        isSelect(field) ? getSelectOptions(field) : undefined
                      "
                      :prepend-inner-icon="selecIcon(field)"
                      outlined
                      dense
                      :disabled="
                        (field.name === 'city' && !formModel.department) ||
                        field.name === 'postalCode' || 
                        (field.name === 'identificationNumber' && !formModel.typeOfIdentification)
                      "
                      :type="field.name === 'dateOfBirth' ? 'date' : ''"
                      @focus="
                        field.name === 'dateOfBirth' &&
                          $event.target.showPicker?.()
                      "
                      @keypress="handleKeypress($event, field)"
                      @paste="handlePaste($event, field)"
                      :rules="getRules(field)"
                      :readonly="
                        lockValidatedFields &&
                        (field.name === 'identificationNumber' ||
                        field.name === 'typeOfIdentification')
                      "
                    />
                  </template>

                  <!-- CHECKBOX -->
                  <v-checkbox
                    v-else
                    v-model="formModel[field.name]"
                    :label="field.alias || field.description"
                    dense
                    class="mt-1"
                    :rules="
                      field.required
                        ? [(v) => v === true || 'Debe aceptar']
                        : []
                    "
                  />
                </v-col>
                <v-alert outlined border="left" class="custom-alert" closable>
                  <div class="legal_text" v-html="legalTextHtml"></div>
                </v-alert>
              </v-row>
              <v-row justify="center">
                <v-col cols="12" sm="6">
                  <v-alert
                    v-if="showAlert"
                    :type="alertType"
                    dense
                    outlined
                    border="left"
                    colored-border
                    class="my-4"
                  >
                    {{ alertMessage }}
                  </v-alert>
                </v-col>
              </v-row>
              <v-btn
                color="rgb(204 33 40)"
                class="mt-6 white--text"
                :disabled="isSaveDisabled"
                @click.prevent="save"
              >
                {{ isEditing ? "Actualizar Datos" : "Guardar Datos" }}
              </v-btn>
            </v-form>
          </div>
        </v-card-text>
      </base-card>
    </v-container>
    <v-overlay :value="loading" opacity="0.6" z-index="9999">
      <v-progress-circular
        indeterminate
        size="64"
        color="rgb(204 33 40)"
      ></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="showValidatorModal" persistent max-width="500">
      <v-card class="pa-4">
        <!-- TÍTULO -->
        <v-card-title class="justify-center text-center font-weight-bold tam-ti">
          ¿Ya eres cliente de nosotros?
        </v-card-title>
        <!-- CONTENIDO -->
        <v-card-text class="text-center">
          <p class="mb-6">Te invitamos a que te registres</p>
          <v-form ref="validatorFormRef" v-model="isValidatorFormValid">
            <v-col
              v-for="field in filteredVisibleFormConfig"
              :key="field.id"
              cols="12"
            >
              <v-select
                v-if="field.description == 'Tipo de identificación'"
                v-model="validatorForm.documentType"
                :items="selectOptions['typeOfIdentification']"
                item-text="text"
                item-value="value"
                :label="field.alias || field.description"
                prepend-inner-icon="mdi mdi-card-account-details-outline"
                outlined
                dense
                required
              />

              <v-text-field
                v-if="field.description == 'Número de identificación'"
                ref="valIdentification"
                :label="field.alias || field.description"
                v-model="validatorForm.documentNumber"
                outlined
                dense
                prepend-inner-icon="mdi mdi-card-account-details"
                :error-messages="validatorError"
                required
                :disabled="(!validatorForm.documentType)"
                :rules="getRulesModal()"
                @keypress="handleKeypressModal($event)"
                @paste="handlePasteModal($event)"
              />
            </v-col>
          </v-form>
        </v-card-text>

        <!-- BOTÓN -->
        <v-card-actions class="justify-center">
          <v-btn
            color="rgb(204 33 40)"
            class="white--text px-10"
            :loading="checkingUser"
            :disabled="
              !validatorForm.documentType || !validatorForm.documentNumber
            "
            @click="validateClient"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showModalResponse"
      persistent
      max-width="500"
    >
      <v-card class="pa-6">
        <v-card-text class="text-center">
          <p class="mb-4 font-weight-medium">
            <strong>¡Registro exitoso!</strong> Indica tu número de identificación al cajero para facturar:
          </p>

          <div class="text-h5 font-weight-bold">
            {{ formModel.identificationNumber }}
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showModalExist"
      persistent
      max-width="500"
    >
      <v-card class="pa-6">
        <v-card-text class="text-center">
          <p class="mb-4 font-weight-medium">
            <template>
              {{ this.messageResponse }}
            </template>
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { environment } from "@/data/environment";
import { VTextField, VSelect, VCheckbox } from "vuetify/lib";

export default {
  name: "HabeasData",
  components: {
    VTextField,
    VSelect,
    VCheckbox,
  },
  data() {
    return {
      loading: false,
      formConfig: [],
      formModel: {},
      selectOptions: {
        genero: [
          { text: "Masculino", value: "Masculino" },
          { text: "Femenino", value: "Femenino" },
        ],
        typeOfIdentification: [],
        department: [],
      },
      allCities: [],
      titleForm: "",
      imageLogo: "",
      legal_text: "",
      legal_highlight: "",
      legal_url: "",
      formValid: false,
      showAlert: false,
      alertMessage: "",
      alertType: "success",
      showValidatorModal: true,
      checkingUser: false,
      clientExists: false,
      validatorError: "",
      validatorForm: {
        documentType: null,
        documentNumber: "",
      },
      showModalResponse: false,
      lockValidatedFields: false,
      lockValidatedFieldsExist: false,
      isEditing: false,
      showModalExist: false,
      isValidatorFormValid: false,
      messageResponse: "",
    };
  },
  mounted() {
    this.getFormCompany();
  },
  computed: {
    isSaveDisabled() {
      return this.formModel.dataProcessing !== true;
    },
    filteredCities() {
      if (!this.formModel.department) return [];
      return this.allCities.filter(
        (c) => c.idProvincia === this.formModel.department
      );
    },
    legalTextHtml() {
      if (!this.legal_text || !this.legal_highlight || !this.legal_url) {
        return this.legal_text;
      }

      const escapedText = this.legal_highlight.replace(
        /[-/\\^$*+?.()|[\]{}]/g,
        "\\$&"
      );

      const regex = new RegExp(escapedText);

      return this.legal_text.replace(
        regex,
        `<a class="legal_link" href="${this.legal_url}" target="_blank">
          ${this.legal_highlight}
        </a>`
      );
    },
    visibleFormConfig() {
      return this.formConfig.filter((f) => f.visible !== false);
    },
    isAddressBlockRequired() {
      return !!(
        this.formModel.address ||
        this.formModel.department ||
        this.formModel.city ||
        this.formModel.postalCode
      );
    },
    labelIdentification() {
      return this.validatorForm.documentType === 12
        ? 'Número + Dígito de verificación sin guión'
        : 'Número de identificación';
    },
    filteredVisibleFormConfig() {
      return this.visibleFormConfig.filter(field =>
        [
          'Tipo de identificación',
          'Número de identificación'
        ].includes(field.description)
      );
    }
  },
  watch: {
    "formModel.department"(newVal) {
      this.formModel.city = null;
      this.formModel.postalCode = null;
    },

    "formModel.city"(newVal) {
      if (!newVal) {
        this.formModel.postalCode = null;
        return;
      }

      const city = this.allCities.find((c) => c.value === this.formModel.city);

      this.formModel.postalCode = city?.code || null;
    },
    "formModel.typeOfIdentification"() {
      if (this.lockValidatedFields || this.lockValidatedFieldsExist) return;
      this.formModel.identificationNumber = null;

      this.$nextTick(() => {
        const fieldRef = this.$refs.identificationNumber;

        if (Array.isArray(fieldRef) && fieldRef[0]?.validate) {
          fieldRef[0].validate();
        }
      });
    },
    "validatorForm.documentType"() {
      this.validatorForm.documentNumber = null;
      this.$nextTick(() => {
        const fieldRef = this.$refs.valIdentification;

        if (Array.isArray(fieldRef) && fieldRef[0]?.validate) {
          fieldRef[0].validate();
        }
      });
    },
    isAddressBlockRequired(newVal) {
      if (!newVal) return;

      this.$nextTick(() => {
        ['address', 'department', 'city', 'postalCode'].forEach(ref => {
          const fieldRef = this.$refs[ref];
          if (Array.isArray(fieldRef) && fieldRef[0]?.validate) {
            fieldRef[0].validate();
          }
        });
      });
    },
    "validatorForm.documentNumber"(value) {
      if (this.validatorForm.documentType === 12) {
        const fieldRef = this.$refs.valIdentification;

        if (Array.isArray(fieldRef) && fieldRef[0]?.validate) {
          fieldRef[0].validate();
        }
      }
    }
  },
  methods: {
    async getFormCompany() {
      try {
        this.loading = true;

        const token = this.$route.params.token;

        const { data } = await axios.post(
          `${environment.HIOPOSWEBSERVICES}/api/habeas-data/get-form-by-token`,
          { token }
        );

        if (!data.error) {
          this.formConfig = data.data;
          this.selectOptions["typeOfIdentification"] = data.typeDocument;
          this.selectOptions["department"] = data.department;
          this.allCities = data.city;
          this.titleForm = data.title_form;
          this.imageLogo = environment.HIOPOSWEBSERVICES + "/" + data.logo;
          this.legal_text = data.legal_text;
          this.legal_highlight = data.legal_highlight;
          this.legal_url = data.legal_url;
          this.initFormModel();
        }
      } catch (error) {
        console.error("Error al obtener el formulario:", error);
      } finally {
        this.loading = false;
      }
    },
    initFormModel() {
      this.formConfig.forEach((field) => {
        this.$set(this.formModel, field.name, null);
      });
    },
    resolveComponent(field) {
      const map = {
        email: "v-text-field",
        names: "v-text-field",
        identificationNumber: "v-text-field",
        cellPhone: "v-text-field",
        phone: "v-text-field",
        address: "v-text-field",
        city: "v-select",
        department: "v-select",
        postalCode: "v-text-field",
        dateOfBirth: "v-text-field",
        genero: "v-select",
        typeOfIdentification: "v-select",
      };

      return map[field.name] || "v-text-field";
    },
    selecIcon(field) {
      const map = {
        email: "mdi mdi-email",
        names: "mdi mdi-account-tag",
        identificationNumber: "mdi mdi-card-account-details",
        cellPhone: "mdi mdi-cellphone-arrow-down",
        phone: "mdi mdi-phone",
        address: "mdi mdi-map-marker",
        city: "mdi mdi-home-city",
        department: "mdi mdi-city",
        postalCode: "mdi mdi-code-equal",
        dateOfBirth: "mdi mdi-calendar-account-outline",
        genero: "mdi mdi-account-sync-outline",
        typeOfIdentification: "mdi mdi-card-account-details-outline",
      };

      return map[field.name] || "mdi mdi-email";
    },
    isCheckbox(field) {
      return ["dataProcessing", "sendingCommercialInformation", "termsAndConditions"].includes(
        field.name
      );
    },
    getSelectOptions(field) {
      if (field.name === "city") {
        return this.filteredCities;
      }
      return this.selectOptions[field.name] || [];
    },
    isSelect(field) {
      return [
        "genero",
        "typeOfIdentification",
        "department",
        "city",
      ].includes(field.name);
    },
    async save() {
      this.loading = true;

      const isValid = this.$refs.form?.validate?.();
      if (!isValid) {
        this.setAlert(
          "error",
          "Por favor, complete todos los campos obligatorios."
        );
        this.loading = false;
        return;
      }

      try {
        if (this.formModel.typeOfIdentification === 12) {

          const nitSinDv = this.formModel.identificationNumber;
          const dvCalculado = this.calcularDigitoVerificador(nitSinDv);
          this.formModel.identificationNumber = `${nitSinDv}${dvCalculado}`;
        }
        const token = this.$route.params.token;

        const response = await axios.post(
          `${environment.HIOPOSWEBSERVICES}/api/habeas-data/save-data-client`,
          {
            token,
            data: this.formModel,
          }
        );

        if (response.data.error) {
          this.setAlert("error", response.data.message);
        } else {
          this.setAlert("success", response.data.message);
          this.showModalResponse = true;
          const FIVE_MINUTES = 5 * 60 * 1000;
          setTimeout(() => {
            this.showModalResponse = false;
            this.resetForm();
            this.$router.go(0)
          }, FIVE_MINUTES);
        }
      } catch (error) {
        console.error("Error guardando datos:", error);
        this.setAlert("error", "Error al guardar la información.");
      } finally {
        this.loading = false;
      }
    },
    setAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.showAlert = true;
      setTimeout(() => (this.showAlert = false), 4000);
    },
    getRules(field) {
      const rules = [];

      // Requerido
      if (field.required) {
        rules.push((v) => !!v || "Este campo es obligatorio");
      }

      // Nombres y apellidos (solo letras y tildes)
      if (["names"].includes(field.name)) {
        rules.push(
          (v) =>
            !v ||
            /^[A-Za-zÁÉÍÓÚáéíóúÑñ0-9._\-\s]+$/.test(v) ||
            "Solo se permiten letras, números, puntos, guiones y guion bajo"
        );
      }

      // Teléfono y celular (solo números)
      if (["cellPhone", "phone"].includes(field.name)) {
        rules.push(
          (v) =>
            !v ||
            /^\d+$/.test(v) ||
            "Solo se permiten números, sin puntos ni caracteres especiales"
        );
      }

      if (field.name === "email") {
        rules.push(
          (v) => {
            if (!v) return true;

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            // Validar formato general
            if (!emailRegex.test(v)) {
              return "Correo inválido";
            }

            // Validar que solo tenga un @
            const atCount = (v.match(/@/g) || []).length;
            if (atCount !== 1) {
              return "El correo solo puede contener un @";
            }

            return true;
          }
        );
      }

      if (field.name === "identificationNumber") {

        const numericDocs = new Set([7, 8, 9, 12, 47]);

        rules.push(v => {
          if (!v) return true;

          // Bloquear consumidor final DIAN
          if (v === "222222222222") {
            return "El número de identificación es inválido";
          }

          // Validación NIT
          if (this.formModel.typeOfIdentification === 12) {
            return this.validateNit(v);
          }

          // Documentos solo numéricos
          if (numericDocs.has(this.formModel.typeOfIdentification)) {
            return (
              /^\d+$/.test(v) ||
              "Solo se permiten números, sin puntos ni caracteres especiales"
            );
          }

          // Documentos alfanuméricos
          return (
            /^[A-Za-z0-9]+$/.test(v) ||
            "Solo se permiten letras y números"
          );
        });
      }

      const addressFields = ['address', 'department', 'city', 'postalCode'];

      if (
        addressFields.includes(field.name) &&
        this.isAddressBlockRequired
      ) {
        rules.push(v => !!v || "Este campo es obligatorio");
      }
      return rules;
    },
    async validateClient() {
      const isValid = this.$refs.validatorFormRef?.validate();

      if (!isValid) {
        return;
      }

      if (!this.validatorForm.documentNumber) {
        this.validatorError = "Debe ingresar el número de identificación";
        return;
      }

      if (!this.validatorForm.documentType) {
        this.validatorError = "Debe seleccionar el tipo de documento";
        return;
      }

      this.validatorError = "";
      this.checkingUser = true;

      try {
        let documentDigit = this.validatorForm.documentNumber;
        if (this.validatorForm.documentType === 12) {

          const nitSinDv = this.validatorForm.documentNumber;
          const dvCalculado = this.calcularDigitoVerificador(nitSinDv);

          documentDigit = `${nitSinDv}${dvCalculado}`;
        }
        const token = this.$route.params.token;

        const response = await axios.post(
          `${environment.HIOPOSWEBSERVICES}/api/habeas-data/validate-client`,
          {
            token,
            document_type: this.validatorForm.documentType,
            document_number: documentDigit,
          }
        );
        this.messageResponse = response.data.message;
        if (response.data.isEdit != 0) {
          this.isEditing = true;
        }
        if (response.data.error == false) {
          this.showValidatorModal = false;
          const backendToFormMap = {
            Documento: "identificationNumber",
            IdHiopos: "typeOfIdentification",
            Nombres: "names",
            Correo: "email",
            Celular: "cellPhone",
            Telefono: "phone",
            Direccion: "address",
            Departamento: "department",
            Ciudad: "city",
            ZonaPostal: "postalCode",
            FechaNacimiento: "dateOfBirth",
            Genero: "genero",
            AceptaTratamientoDatos: "dataProcessing",
            AceptaEnvioComercial: "sendingCommercialInformation",
            AceptaTerminosCondiciones: "termsAndConditions",
          };

          const clientData = response.data.client;

          this.mapClientDataFromBackend(clientData, backendToFormMap);
          this.formModel.identificationNumber = this.validatorForm.documentNumber
          this.formModel.typeOfIdentification = this.validatorForm.documentType
          this.lockValidatedFields = true;
          this.showModalExist = true;
          setTimeout(() => {
            this.showModalExist = false;
          }, 9000);
        } else {
          this.showValidatorModal = false;
          this.formModel.identificationNumber = this.validatorForm.documentNumber
          this.formModel.typeOfIdentification = this.validatorForm.documentType
          this.lockValidatedFields = true;
          this.showModalExist = true;
          setTimeout(() => {
            this.showModalExist = false;
          }, 5000);
        }
      } catch (e) {
        this.validatorError = "Error validando el documento";
        console.error(e);
      } finally {
        this.checkingUser = false;
      }
    },
    resetForm() {
      // Limpiar modelo
      Object.keys(this.formModel).forEach(key => {
        this.formModel[key] = null;
      });

      // Reset validaciones
      this.$nextTick(() => {
        this.$refs.form?.resetValidation?.();
      });
    },
    handleKeypress(event, field) {
      // Solo aplica a número de identificación
      if (field.name !== "identificationNumber") return;

      const numericDocs = new Set([7, 8, 9, 12, 47]);

      // Si aún no hay tipo de documento, no permitir escribir
      if (!this.formModel.typeOfIdentification) {
        event.preventDefault();
        return;
      }

      // Permitir teclas de control
      const allowedKeys = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
      ];

      if (allowedKeys.includes(event.key)) return;

      // Documentos solo numéricos
      if (numericDocs.has(this.formModel.typeOfIdentification)) {
        if (!/^\d$/.test(event.key)) {
          event.preventDefault();
        }
        return;
      }

      // Documentos alfanuméricos
      if (!/^[A-Za-z0-9]$/.test(event.key)) {
        event.preventDefault();
      }
    },
    handlePaste(event, field) {
      if (field.name !== "identificationNumber") return;

      const numericDocs = new Set([7, 8, 9, 12, 47]);
      const pasted = event.clipboardData.getData("text");

      if (
        numericDocs.has(this.formModel.typeOfIdentification) &&
        !/^\d+$/.test(pasted)
      ) {
        event.preventDefault();
      }
    },
    getRulesModal() {
      const numericDocs = new Set([7, 8, 9, 12, 47]);

      return [
        // Reglas de tipo (números / alfanumérico)
        v => {
          if (!v) return true;

          // Validación NIT
          if (this.validatorForm.documentType === 12) {
            return this.validateNit(v);
          }

          if (numericDocs.has(this.validatorForm.documentType)) {
            return (
              /^\d+$/.test(v) ||
              "Solo se permiten números, sin puntos ni caracteres especiales"
            );
          }

          return (
            /^[A-Za-z0-9]+$/.test(v) ||
            "Solo se permiten letras y números"
          );
        },

        // 🔴 Mínimo 5 caracteres
        v => {
          if (!v) return true;
          return v.length >= 5 || "Debe tener mínimo 5 caracteres";
        }
      ];
    },
    handlePasteModal(event) {

      const numericDocs = new Set([7, 8, 9, 12, 47]);
      const pasted = event.clipboardData.getData("text");

      if (
        numericDocs.has(this.validatorForm.documentType) &&
        !/^\d+$/.test(pasted)
      ) {
        event.preventDefault();
      }
    },
    handleKeypressModal(event) {

      const numericDocs = new Set([7, 8, 9, 12, 47]);

      // Si aún no hay tipo de documento, no permitir escribir
      if (!this.validatorForm.documentType) {
        event.preventDefault();
        return;
      }

      // Permitir teclas de control
      const allowedKeys = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
      ];

      if (allowedKeys.includes(event.key)) return;

      // Documentos solo numéricos
      if (numericDocs.has(this.validatorForm.documentType)) {
        if (!/^\d$/.test(event.key)) {
          event.preventDefault();
        }
        return;
      }

      // Documentos alfanuméricos
      if (!/^[A-Za-z0-9]$/.test(event.key)) {
        event.preventDefault();
      }
    },
    mapClientDataFromBackend(clientData, backendToFormMap) {
      // Desactivar temporalmente el watcher
      const originalLockState = this.lockValidatedFieldsExist;
      this.lockValidatedFieldsExist = true;

      // Variables temporales para almacenar departamento y ciudad
      let tempDepartment = null;
      let tempCity = null;

      // Primera pasada: extraer departamento y ciudad
      Object.keys(backendToFormMap).forEach(backendKey => {
        const formKey = backendToFormMap[backendKey];
        
        if (clientData[backendKey] !== undefined && clientData[backendKey] !== null) {
          
          // Guardar departamento
          if (formKey === 'department') {
            const dept = this.selectOptions.department.find(
              d => d.text?.toLowerCase() === clientData[backendKey]?.toLowerCase()
            );
            tempDepartment = dept?.value || null;
          }
          
          // Guardar ciudad
          if (formKey === 'city') {
            const city = this.allCities.find(
              c => c.text?.toLowerCase() === clientData[backendKey]?.toLowerCase()
            );
            tempCity = city?.value || null;
          }
        }
      });

      // Asignar departamento primero
      if (tempDepartment !== null) {
        this.formModel.department = tempDepartment;
      }

      // Esperar al siguiente tick y luego asignar ciudad
      this.$nextTick(() => {
        if (tempCity !== null) {
          this.formModel.city = tempCity;
        }

        // Asignar el resto de campos
        Object.keys(backendToFormMap).forEach(backendKey => {
          const formKey = backendToFormMap[backendKey];
          
          // Saltar departamento y ciudad que ya fueron asignados
          if (formKey === 'department' || formKey === 'city') return;
          
          if (clientData[backendKey] !== undefined && clientData[backendKey] !== null) {
            this.formModel[formKey] = clientData[backendKey];
          }
        });
        
        // Manejar conversiones especiales (0/1 a boolean)
        if (clientData.AceptaTratamientoDatos !== undefined) {
          this.formModel.dataProcessing = Boolean(clientData.AceptaTratamientoDatos);
        }
        
        if (clientData.AceptaEnvioComercial !== undefined) {
          this.formModel.sendingCommercialInformation = Boolean(clientData.AceptaEnvioComercial);
        }

      });
    },
    validateNit(nit) {

      if (!/^\d+$/.test(nit)) {
        return "El NIT solo debe contener números";
      }

      if (nit.length < 5) {
        return "El NIT es demasiado corto";
      }

      const prefijosValidos = ['800', '811', '830', '860', '900', '901', '902', '911'];
      const prefijo = nit.substring(0, 3);

      if (!prefijosValidos.includes(prefijo)) {
        return "El NIT no inicia con un rango válido";
      }

      return true;
    },
    calcularDigitoVerificador(nit) {

      const arr = {
        1: 3, 2: 7, 3: 13, 4: 17, 5: 19,
        6: 23, 7: 29, 8: 37, 9: 41, 10: 43,
        11: 47, 12: 53, 13: 59, 14: 67, 15: 71
      };

      let x = 0;
      const z = nit.length;

      for (let i = 0; i < z; i++) {
        const y = parseInt(nit.substr(i, 1));
        x += y * arr[z - i];
      }

      let y = x % 11;

      if (y > 1) {
        return 11 - y;
      }

      return y;
    },
    getFieldLabel(field) {
      if (
        field.description === 'Nombres y Apellidos' &&
        this.validatorForm.documentType === 12
      ) {
        return 'Razón Social';
      }

      return field.alias || field.description;
    }
  },
};
</script>
<style scoped>
.v-card {
  border-radius: 18px;
}
.field-label {
  font-size: 18px;
  margin-bottom: 6px;
  text-align: start;
}
.required-asterisk {
  color: rgb(204 33 40);
  font-size: 15px;
}
.count-input {
  font-size: 14px;
  color: rgb(204 33 40);
}
.mw-container {
  max-width: 80%;
}

.logo {
  height: auto;
  max-width: 120px;
}

.title {
  font-size: 20px;
  font-weight: 600;
  text-align: center;
}

.custom-alert {
  border-left-width: 4px;
  width: 100%;
}
.legal_text {
  font-size: small;
}

:deep(.legal_link) {
  font-weight: 800;
  font-size: 0.95rem;
  color: rgb(204 33 40);
  text-decoration: underline;
}

:deep(.legal_link:hover) {
  text-decoration: none;
}

.title h3 {
  word-break: keep-all;
  overflow-wrap: normal;
}

.tam-ti {
  word-break: keep-all;
  overflow-wrap: normal;
}
</style>
